import { constantNetwork } from 'constants/network'
import { makeAutoObservable } from 'mobx'

interface blockInfo {
  chainId: string
  height: number
  timeStamp: number
}
class NetworkStore {
  block: blockInfo
  gasPrice: string
  taxRate: string

  constructor() {
    this.block = {
      chainId: constantNetwork.mainnet.chainID,
      height: 0,
      timeStamp: 0,
    }
    makeAutoObservable(this)
  }

  setBlock = (block: blockInfo) => {
    this.block = block
  }

  setGasPrice = (gasPrice: string) => {
    this.gasPrice = gasPrice
  }

  setTaxRate = (taxRate: string) => {
    this.taxRate = taxRate
  }
}

export const networkStore = new NetworkStore()
